import qs from 'qs'
import toast from 'react-hot-toast'
import { useSetRecoilState } from 'recoil'

import { fundSupervisionPop, inRoom } from '@/api/center'
import { fromStrState, fundSupervisionPopState } from '@/store/global'
import { checkOS, getBrowser } from '@/utils/tool'

export default function Index() {
  const setFundSupervisionPop = useSetRecoilState(fundSupervisionPopState)
  const setFromStr = useSetRecoilState(fromStrState)

  const to1v1Room = (formData: any) => {
    console.log(formData)
    const { name, ver } = getBrowser().Sys
    const model = `${name} ${ver}`
    inRoom({
      lessonType: formData.lessonType,
      roomId: formData.roomId,
      lessonTimeId: formData.timesId,
      userId: formData.userId,
      courseId: formData.courseId
      // sys: `PC-${checkOS()}`,
      // buildVersion: import.meta.env.VITE_APP_TIME,
      // ver: ver,
      // browser: model
    }).then((res: any) => {
      if (res.status === 0) {
        const fromStr = qs.stringify({ ...formData, ...res.data.breadInClassInfo, roomType: 1 })
        if (formData.lessonType === 1) {
          // 正式课 资金监管 用户点击弹窗上报
          fundSupervisionPop({ timesId: formData.timesId }).then((res) => {
            const { data } = res
            if (data) {
              jumpRoom(fromStr)
            } else {
              setFundSupervisionPop(true)
              setFromStr(fromStr)
            }
          })
        } else {
          jumpRoom(fromStr)
        }
      } else {
        toast.error(res.msg)
      }
    })
  }

  const jumpRoom = (fromStr: string) => {
    console.log(fromStr)
    // window.location.href = import.meta.env.VITE_APP_home + '/classclient/#/?' + fromStr
    window.location.href = `/student/room?${fromStr}`
  }

  return [to1v1Room, jumpRoom] as const
}
